// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DBEFT","top":"styles_top__1pa8T"};